import { AdsDetailApi } from '../../api'
import { setRegistrationFormulaDetails } from '../setRegistrationFormulaDetails'

export const fetchRegistrationFormulaDetails = id => async dispatch => {
  const api = new AdsDetailApi()
  const formula = await api.getRegistrationFormulaDetails(id)
  dispatch(setRegistrationFormulaDetails(formula))
}
